import PlayStoreLogo from '../images/android.png'
import AppStoreLogo from '../images/appstore.png'
import { useContext, useState, useEffect } from 'react'

import UserContext from '../UserContext'
import LoginFooter from './LoginFooter'

function Footer() {
  const { mode } = useContext(UserContext)
  // setting the theme
  const [dark, setDark] = useState(false)
  useEffect(() => {
    let darkmode = localStorage.getItem('darkmode')
      ? JSON.parse(localStorage.getItem('darkmode'))
      : false
    setDark(darkmode)
  }, [mode])

  return (
    <footer className={dark ? 'footer darkmode' : 'footer md:px-60'}>
      <LoginFooter/>
      <div className='text-center'>
        <h1>Make hommies via Twika</h1>
      </div>
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3'>
        <div className=''>
          <ul className='block md:flex gap-5'>
            <li>
              <a href='about.html'>About us</a>
            </li>
            <li>
              <a href='blog.html'>Provacy Policy</a>
            </li>
            <li>
              <a href='blog.html'>Terms of Services</a>
            </li>
            <li>
              <a href='blog.html'>Copyright Policy</a>
            </li>
          </ul>
        </div>
        <div className='text-center my-2'>
          <h6 style={dark ? { color: '#fff' } : {}} className='text-sm'>
            Get Twika app - <span>It's all about fun.</span>
          </h6>
          <div className='download-with-app my-3'>
            <img src={PlayStoreLogo} alt='Google Play Store' />
            <img src={AppStoreLogo} alt='Apple App Store' />
          </div>
        </div>
        <div className=''>
          <ul className='list-unstyled d-flex flex-wrap gap-x-4 justify-end'>
            <li>
              <a href='about.html'>Twika Community</a>
            </li>
            <li>
              <a href='blog.html'>Community Guidelines</a>
            </li>
            <li>
              <a href='blog.html'>Honor Account</a>
            </li>
            <li>
              <a href='blog.html'>Developer</a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  )
}

export default Footer
